<script>
	import { ABOUT_US } from '$lib/routes'
	import { t } from '$lib/translations'
	import { Button } from '.'

	export let content = null
</script>

<div class="flex">
	<div class="left">
		<h3 class="text-white">
			{content?.description || t('web.components.videoBanner.defaultDescription')}
		</h3>
		<div>
			<Button href={content?.button_url || `/${ABOUT_US}`} secondary>
				{content?.button_title || t('web.heat_pump.brand.whyWoltair')}
			</Button>
		</div>
	</div>
	<div class="right">
		<video
			loop
			autoplay
			muted
			playsinline
			src={content?.video?.url || '/videos/smycka.mov'}
			type="video/mov"
		/>
	</div>
</div>

<style lang="scss">
	.flex {
		background: #e20613;
		display: flex;
		margin: 50px 0;

		@media only screen and (max-width: 760px) {
			flex-direction: column;
			position: relative;
			width: 100vw;
			left: -15px;
			margin: 0;
		}

		.left {
			width: 50%;
			padding: 50px;
			display: flex;
			flex-direction: column;
			justify-content: space-between;

			@media only screen and (max-width: 760px) {
				width: 100%;
				padding: 20px;
			}
		}

		.right {
			width: 50%;
			overflow: hidden;

			@media only screen and (max-width: 760px) {
				width: 100%;
			}

			video {
				display: block;
				width: 100%;
				height: 100%;
				object-fit: cover;
			}
		}
	}
</style>
